var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            no: "dialog",
            visible: _vm.visible,
            title: _vm.$t("CargoMsg.Cargo_SelectSob"),
            width: "630px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            top: "5vh",
            "custom-class": "account-set-popup"
          },
          on: { open: _vm.showDialog }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { "margin-top": "4px" },
              attrs: {
                inline: true,
                "label-width": "60px",
                "label-position": "left"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { padding: "0" }
                },
                [
                  _vm.mode === "tenant"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "el-form-item-w250",
                          attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCMP") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "currentOfficeId",
                                placeholder: _vm.$t(
                                  "CargoMsg.Cargo_PleaseSelectP"
                                ),
                                filterable: ""
                              },
                              on: { change: _vm.officeChangeHandler },
                              model: {
                                value: _vm.currentOfficeId,
                                callback: function($$v) {
                                  _vm.currentOfficeId = $$v
                                },
                                expression: "currentOfficeId"
                              }
                            },
                            _vm._l(_vm.currentOfficeList, function(office) {
                              return _c("el-option", {
                                key: office.officeId,
                                attrs: {
                                  label: _vm.isZh
                                    ? office.chineseName
                                    : office.englishName,
                                  value: office.officeId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "65px" },
                          attrs: { no: "Refresh", type: "primary" },
                          on: { click: _vm.refreshHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refresh")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row row-grid",
                  staticStyle: { "min-height": "320px", padding: "0" }
                },
                [
                  _c("cargo-ag-grid", {
                    style: { width: "610px", height: "321px" },
                    attrs: {
                      no: "grid",
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "auto-fit-content": false
                    }
                  })
                ],
                1
              ),
              _vm.mode === "tenant" && _vm.isWT
                ? _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row",
                      staticStyle: {
                        padding: "0px",
                        "margin-top": "5px",
                        "margin-bottom": "-11px",
                        "justify-content": "flex-start"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_InitialPeriod")
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*")
                          ]),
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "10px" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_PeriodRange"))
                              )
                            ]
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "130px" },
                            attrs: {
                              no: "dfBeginDate",
                              type: "date",
                              clearable: false,
                              "value-format": "yyyy-MM-dd",
                              editable: false
                            },
                            on: { change: _vm.dateChangeHandler },
                            model: {
                              value: _vm.dfBeginDate,
                              callback: function($$v) {
                                _vm.dfBeginDate = $$v
                              },
                              expression: "dfBeginDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "130px" },
                            attrs: {
                              no: "dfEndDate",
                              type: "date",
                              clearable: "",
                              "value-format": "yyyy-MM-dd",
                              disabled: true
                            },
                            model: {
                              value: _vm.dfEndDate,
                              callback: function($$v) {
                                _vm.dfEndDate = $$v
                              },
                              expression: "dfEndDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: {
                            position: "absolute",
                            right: "0",
                            "padding-right": "10px"
                          },
                          attrs: { "label-width": "0px" }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "60px" },
                            attrs: { no: "yearTxt", disabled: true },
                            model: {
                              value: _vm.yearTxt,
                              callback: function($$v) {
                                _vm.yearTxt = $$v
                              },
                              expression: "yearTxt"
                            }
                          }),
                          _c("span", { staticStyle: { "font-size": "12px" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_Year")) + " "
                            )
                          ]),
                          _c("el-input", {
                            staticStyle: { width: "60px" },
                            attrs: { no: "monthTxt", disabled: true },
                            model: {
                              value: _vm.monthTxt,
                              callback: function($$v) {
                                _vm.monthTxt = $$v
                              },
                              expression: "monthTxt"
                            }
                          }),
                          _c("span", { staticStyle: { "font-size": "12px" } }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("CargoMsg.Cargo_Period")) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _c(
            "div",
            {
              staticStyle: { height: "25px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.mode === "tenant"
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        position: "absolute",
                        left: "0",
                        "padding-left": "10px"
                      }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            inline: true,
                            "label-width": "60px",
                            "label-position": "left"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w200",
                              attrs: { label: _vm.$t("CargoMsg.Cargo_SobName") }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "txtAccountSetName" },
                                model: {
                                  value: _vm.txtAccountSetName,
                                  callback: function($$v) {
                                    _vm.txtAccountSetName = $$v
                                  },
                                  expression: "txtAccountSetName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w200",
                              attrs: { label: _vm.$t("CargoMsg.Cargo_SobCode") }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "txtCode" },
                                model: {
                                  value: _vm.txtCode,
                                  callback: function($$v) {
                                    _vm.txtCode = $$v
                                  },
                                  expression: "txtCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "0",
                    "padding-right": "10px"
                  }
                },
                [
                  _vm.mode === "office"
                    ? _c(
                        "el-button",
                        {
                          attrs: { no: "SetToCurrentSob", type: "primary" },
                          on: { click: _vm.onOK }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_SetToCurrentSob"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.mode === "tenant"
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { width: "65px", "margin-left": "5px" },
                          attrs: { no: "Select", type: "primary" },
                          on: { click: _vm.onOK }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Select")))]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "65px", "margin-left": "5px" },
                      attrs: { no: "Cancel" },
                      on: { click: _vm.onCancel }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }